import type { LucideIcon } from 'lucide-react';
import {
	BarChart3,
	Bell,
	BookOpen,
	CheckSquare,
	ClipboardList,
	CreditCard,
	DollarSign,
	GitBranch,
	Globe,
	House,
	Layers,
	Lock,
	Mail,
	Network,
	Package,
	Radar,
	Settings,
	Shield,
	UserCheck,
	Users,
} from 'lucide-react';
import { Routes } from '@/routes/routes';

export interface TMainMenu {
	title: string;
	url?: string;
	icon?: LucideIcon;
	isActive?: boolean;
	items?: TMainMenu[];
}

export const mainMenu: TMainMenu[] = [
	{
		title: 'Homepage',
		url: Routes.HOME,
		icon: House,
		isActive: true,
	},

	// ── From index.html ────────────────────────────────────────────
	{
		title: 'Customers & KYC',
		icon: UserCheck,
		items: [
			{ title: 'Assign Agent' },
			{ title: 'Assigned eKyc List' },
			{ title: 'Customers' },
			{ title: 'Config' },
		],
	},
	{
		title: 'Digital Goods',
		icon: Package,
	},
	{
		title: 'Communication',
		icon: Mail,
		items: [
			{ title: 'Notification Logs' },
			{ title: 'Manage Template' },
			{ title: 'Config' },
			{ title: 'Connectra' },
		],
	},
	{
		title: 'Alerts',
		icon: Bell,
	},
	{
		title: 'Payments',
		icon: CreditCard,
		items: [
			{
				title: 'User Accounts',
				items: [
					{ title: 'Consumers' },
					{ title: 'Merchants' },
					{ title: 'Vendors' },
				],
			},
			{ title: 'Transactions' },
			{ title: 'Settlements' },
			{ title: 'PesoNet' },
			{
				title: 'Treasury',
				items: [
					{ title: 'Cash' },
					{ title: 'Fee/Tax' },
					{ title: 'Manual Transfer' },
				],
			},
			{
				title: 'Configs',
				items: [
					{ title: 'Channels' },
					{ title: 'Account Types (AT)' },
					{ title: 'AT Mapping' },
					{ title: 'Banks' },
				],
			},
		],
	},
	{
		title: 'AML',
		icon: Shield,
	},
	{
		title: 'Admin',
		icon: Settings,
	},
	{
		title: 'Audit Trails',
		icon: ClipboardList,
	},
	{
		title: 'Ledger',
		icon: BookOpen,
	},
	{
		title: 'Analytics',
		url: '/analytics',
		icon: BarChart3,
	},
	{
		title: 'Auth',
		icon: Lock,
	},
	{
		title: 'Hierarchy Management',
		icon: Layers,
	},
	{
		title: 'Ontology',
		icon: Globe,
	},
	{
		title: 'GMC',
		icon: CheckSquare,
		items: [
			{ title: 'Configs', url: Routes.GMC_CONFIGS },
			{ title: 'Logs', url: Routes.GMC_LOGS },
		],
	},

	// ── Project-only items (not in index.html) ─────────────────────
	{
		title: 'Risk Radar',
		icon: Radar,
		isActive: true,
		items: [
			{ title: 'Case Manager', url: Routes.RR_CASE_MANAGER },
			{ title: 'Alert Manager', url: Routes.AML_ALERTS },
			{
				title: 'Name Screening',
				icon: DollarSign,
				isActive: true,
				items: [
					{ title: 'Watchlist Search', url: Routes.NS_WATCHLIST_SEARCH },
					{ title: 'Manual Screening', url: Routes.NS_MANUAL_SCREENING },
					{ title: 'Batch Screening', url: Routes.NS_BATCH_SCREENING },
					{ title: 'Delta Screening', url: Routes.NS_SCREENING_SCHEDULE },
					{
						title: 'Configuration',
						icon: DollarSign,
						isActive: true,
						items: [
							{ title: 'Alerts', url: Routes.NS_THRESHOLD },
							{ title: 'Screening', url: Routes.NS_CONFIG },
						],
					},
				],
			},
			{
				title: 'Transaction Monitoring',
				items: [{ title: 'Transaction Monitoring', url: '/tms/rules' }],
			},
			{
				title: 'Data Ingestion',
				icon: DollarSign,
				isActive: true,
				items: [{ title: 'Watchlist', url: Routes.NS_WATCHLIST_INGESTION }],
			},
			{
				title: 'Dashboards',
				icon: DollarSign,
				isActive: true,
			},
		],
	},
	{
		title: 'Connectra',
		url: Routes.CONNECTRA_ROOT,
		icon: Network,
		isActive: true,
		items: [
			{ title: 'Dashboard', url: Routes.CONNECTRA_ROOT },
			{ title: 'Communications', url: Routes.CONNECTRA_COMMUNICATIONS },
			{ title: 'Client', url: Routes.CONNECTRA_CLIENT },
		],
	},
	{
		title: 'Users',
		url: Routes.USERS_ROOT,
		icon: Users,
		items: [
			{ title: 'User List', url: Routes.USERS_LIST },
			{ title: 'Profile', url: Routes.USERS_PROFILE },
		],
	},
	{ title: 'Repositories', url: '/repositories', icon: GitBranch },
];
